import { PlanUnitDetails } from 'components/types';

export const makeItems = (
  keys: readonly string[],
  costCenterData: PlanUnitDetails | never[] | null,
  t: (key: string) => string
) =>
  keys.map((key) => ({
    label: t(key),
    value: (costCenterData as Record<string, any>)[key]
  }));
